import { UpdateServiceContractRequestBody, UpdateServiceContractResponseBody } from '@boltenergy-be/shared'
import { getAxiosRequestConfigBoltBackend, newRequest } from 'utils/request.ts'
import { Methods, Response } from 'types/request.ts'
import { Flow } from 'types/logging.ts'
import { log } from 'utils/logging.ts'

/**
 * Function to patch a specific service contract and return the new contract data
 *
 * @param {string} serviceContractNumber
 * @param {UpdateServiceContractRequestBody} body
 * @returns {Promise<Response<UpdateServiceContractResponseBody>>}
 */
export const updateServiceContract = async (
  serviceContractNumber: string,
  body: UpdateServiceContractRequestBody
): Promise<Response<UpdateServiceContractResponseBody>> => {
  const res = await newRequest<UpdateServiceContractResponseBody>(
    getAxiosRequestConfigBoltBackend(Methods.PATCH, `/resources/service-contracts/${serviceContractNumber}`, body)
  )

  if (!res.success) {
    log({
      error: res?.message || `unknown error with product switch for contract`,
      identifier: `[${Flow.TARIFFS}:switchProduct${res?.errorCode ? `:${res.errorCode}` : ''}]`,
      errorCode: res?.errorCode,
      metaData: {
        updateServiceContractError: {
          contractNumber: serviceContractNumber,
          body,
          res
        }
      }
    })
  }

  return res
}
